<template>
	<section class="container-fluid mt-2">
		<div class="row mt-2">
			<div class="col-12 col-sm-12 col-md-12 col-lg-12">
				<nav class="navbar navbar-breadcrumb navbar-expand-md bg-breadcrumb breadcrumb-borde">
                    <div class="mr-auto">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb clearfix pt-3">
                                <li class="breadcrumb-item active" style="cursor: pointer;" @click="Regresar()">Proyecto</li>
                                <li class="breadcrumb-item active">Dashboard</li>
                            </ol>
                        </nav>
                    </div>
                </nav>
			</div>
		</div>
		<CLoader :pConfigLoad="ConfigLoad">
			<template slot="BodyFormLoad">
				<div class="row mt-2">
					<div class="col-12 col-sm-12 col-md-12 col-lg-12">
						<div class="card">
							<div class="card-body p-2">
								<div class="row">
									<div class="d-flex px-3" style="flex-basis:20%">
										<div class="card card-body card-sombra-fuerte pt-2 pb-2">
											<!-- <h2 class="bold text-center text-title-desprosoft">Valores</h2>
											<hr> -->
											<h3 class="bold text-center">Venta Plan</h3>
											<h2 class="text-center bold">$ {{formateoMillon(parseFloat(ValorContrato))}}</h2>
											<h3 class="text-center text-info bold">{{ValorContratoPorcen}} %</h3>
											<hr>
											<h3 class="bold text-center">Venta Actual</h3>
											<h2 class="text-center bold">$ {{formateoMillon(parseFloat(VentaActual))}}</h2>
											<h3 class="text-center text-info bold">{{VentaActualPorcen}} %</h3>
											<hr>
											<h3 class="bold text-center">Adicionales</h3>
											<h2 class="text-center bold">$ {{formateoMillon(parseFloat(Adicionales))}}</h2>
											<h3 class="text-center text-info bold">{{AdicionalesPorcen}} %</h3>
											<!-- <h3 class="bold text-center">G&A/V/F</h3>
											<h2 class="text-center bold">$ {{formateoMillon(parseFloat(GA))}}</h2>
											<h3 class="text-center text-info bold">{{GAPorcen}} %</h3> -->
										</div>
									</div>
									<div class="d-flex px-3" style="flex-basis:20%">
										<div class="card card-body card-sombra-fuerte pt-2 pb-2">
											<!-- <h2 class="bold text-center text-title-desprosoft">Gastos</h2>
											<hr> -->
											<h3 class="bold text-center">Gasto Operativo Plan</h3>
											<h2 class="text-center bold">$ {{formateoMillon(parseFloat(CostoOperativo))}}</h2>
											<h3 class="text-center text-info bold">{{CostoOperativoPorcen}} %</h3>
											<hr>
											<!-- <h3 class="bold text-center">Total</h3>
											<h2 class="text-center bold">$ {{formateoMillon(parseFloat(GastoTotal))}}</h2>
											<h3 class="text-center text-info bold">{{GastoTotalPorcen}} %</h3>
											<hr> -->
											<h3 class="bold text-center">Gasto Operativo Actual</h3>
											<h2 class="text-center bold">$ {{formateoMillon(parseFloat(GastoOperativo))}}</h2>
											<h3 class="text-center text-info bold">{{GastoOperativoPorcen}} %</h3>
											<hr>
											<h3 class="bold text-center">Varianza</h3>
											<h2 class="text-center bold">$ {{formateoMillon(parseFloat(VarianzaOperativo))}}</h2>
											<h3 class="text-center text-info bold">{{VarianzaOperativoPorcen}} %</h3>
										</div>
									</div>
									<div class="d-flex px-3" style="flex-basis:20%">
										<div class="card card-body card-sombra-fuerte pt-2 pb-2">
											<h3 class="bold text-center">Costo Empresa Plan</h3>
											<h2 class="text-center bold">$ {{formateoMillon(parseFloat(CostoEmpresaPlan))}}</h2>
											<h3 class="text-center text-info bold">{{CostoEmpresaPlanPorcen}} %</h3>
											<hr>
											<h3 class="bold text-center">Costo Empresa Actual</h3>
											<h2 class="text-center bold">$ {{formateoMillon(parseFloat(CostoEmpresaActual))}}</h2>
											<h3 class="text-center text-info bold">{{CostoEmpresaActualPorcen}} %</h3>
											<hr>
											<h3 class="bold text-center">Varianza</h3>
											<h2 class="text-center bold">$ {{formateoMillon(parseFloat(VarianzaCostoEmpresa))}}</h2>
											<h3 class="text-center text-info bold">{{VarianzaCostoEmpresaPorcen}} %</h3>
										</div>
									</div>
									<div class="d-flex px-3" style="flex-basis:20%">
										<div class="card card-body card-sombra-fuerte pt-2 pb-2">
											<h3 class="bold text-center">Facturado</h3>
											<h2 class="text-center bold">$ {{formateoMillon(parseFloat(Facturado))}}</h2>
											<h3 class="text-center text-info bold">{{FacturadoPorcen}} %</h3>
											<hr>
											<h3 class="bold text-center">Cobrado</h3>
											<h2 class="text-center bold">$ {{formateoMillon(parseFloat(Cobrado))}}</h2>
											<h3 class="text-center text-info bold">{{CobradoPorcen}} %</h3>
											<hr>
											<h3 class="bold text-center">Por Facturar</h3>
											<h2 class="text-center bold">$ {{formateoMillon(parseFloat(PorFacturar))}}</h2>
											<h3 class="text-center text-info bold">{{PorFacturarPorcen}} %</h3>
										</div>
									</div>
									<div class="d-flex px-3" style="flex-basis:20%">
										<div class="card card-body card-sombra-fuerte pt-2 pb-2">
											<h3 class="bold text-center">Utilidad Plan</h3>
											<h2 class="text-center bold">$ {{formateoMillon(parseFloat(UtilidadPlan))}}</h2>
											<h3 class="text-center text-info bold">{{UtilidadPlanPorcen}} %</h3>
											<hr>
											<h3 class="bold text-center">Utilidad Actual</h3>
											<h2 class="text-center bold">$ {{formateoMillon(parseFloat(UtilidadActual))}}</h2>
											<h3 class="text-center text-info bold">{{UtilidadActualPorcen}} %</h3>
											<hr>
											<h3 class="bold text-center">Financiamiento</h3>
											<h2 class="text-center bold">$ {{formateoMillon(parseFloat(Financiamiento))}}</h2>
											<h3 class="text-center text-info bold">{{FinanciamientoPorcen}} %</h3>
										</div>
									</div>
								</div>
								<div class="row mt-4">
									<div class="col-lg-5">
										<div class="card card-body card-sombra-fuerte pt-2 pb-2 h-100">
											<!-- <div class="row">
												<div class="col-lg-12">
													<h2 class="text-center bold text-title-desprosoft">Progreso</h2>
												</div>
											</div>
											<div class="row">
												<div class="col-lg-12">
													<span class="bold">Tiempo</span>
													<div class="barra-progreso-dashboard mt-2 d-flex">
														<div class="barra-progreso-dashboard-relleno" style="background-color:#038ED9" :id="'progresotiempo'">
															<span v-if="ProgresoTiempo>=90" class="h-100 d-flex align-items-center justify-content-end ml-2 bold">{{ProgresoTiempo+' %'}}</span>
														</div>
														<span v-if="ProgresoTiempo<90" class="h-100 d-flex align-items-center ml-2 bold">{{ProgresoTiempo+' %'}}</span>
													</div>
												</div>
											</div>
											<div class="row mt-3">
												<div class="col-lg-12">
													<span class="bold">Obra</span>
													<div class="barra-progreso-dashboard mt-2 d-flex">
														<div class="barra-progreso-dashboard-relleno" style="background-color:#038ED9" :id="'progresoobra'">
															<span v-if="ProgresoObra>=90" class="h-100 d-flex align-items-center justify-content-end ml-2 bold">{{ProgresoObra+' %'}}</span>
														</div>
														<span v-if="ProgresoObra<90" class="h-100 d-flex align-items-center ml-2 bold">{{ProgresoObra+' %'}}</span>
													</div>
												</div>
											</div> -->
											<div class="row mt-3">
												<div class="col-lg-6 p-0">
													<div class="row">
														<div class="col-lg-12">
															<h3 class="text-center bold">Tiempo</h3>
															<jscharting ref="charttiempo" style="height:240px" :mutable="true" :options="OptionsGraficaTiempo" class="columnChart"></jscharting>
														</div>
													</div>
													<div class="row mt-2">
														<div class="col-lg-12">
															<h3 class="text-center bold">Venta Actual</h3>
															<apexchart v-if="ShowPieCostoTotal" height="284" :options="OptionsCostoTotal" :series="SeriesCostoTotal"></apexchart>
														</div>
													</div>
												</div>
												<div class="col-lg-6 p-0">
													<div class="row">
														<div class="col-lg-12">
															<h3 class="text-center bold">Obra</h3>
															<jscharting ref="chartobra" style="height:240px" :mutable="true" :options="OptionsGraficaObra" class="columnChart"></jscharting>
														</div>
													</div>
													<div class="row">
														<div class="col-lg-12 mt-2">
															<h3 class="text-center bold">Costos Operativos</h3>
															<apexchart v-if="ShowPieCostoOperativo" height="284" :options="OptionsCostoOperativo" :series="SeriesCostoOperativo"></apexchart>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-lg-7">
										<div class="card card-body card-sombra-fuerte pt-2 pb-2 h-100" style="font-weight:600 !important">
											<b-overlay :show="isOverlay" rounded="sm" spinner-variant="primary">
												<div class="filtro-grafic" id="grafica_004" v-if="IsGraphicFilterVisible">
													<div class="row justify-content-start">
														<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
															<div class="form-inline mb-2">
																<label class="title-grafic side-l mr-3">Hrs. por Tipo Servicios</label>
																<v-date-picker
																	mode="range"
																	v-model="rangeDate"
																	@input="GetTipoServicio"
																	:input-props="{
																		class: 'form-control form-control-sm mr-2 calendar',
																		placeholder:
																			'Selecciona un rango de fecha para buscar',
																		readonly: true
																	}"
																/>
																<button
																	type="button"
																	class="btn close abs_01"
																	@click="OcultarFiltro()"
																>
																	<i class="fal fa-times"></i>
																</button>
															</div>
														</div>
													</div>
												</div>
												<div class="row mt-2">
													<div class="col-10 col-sm-10 col-md-8 col-lg-8">
														<h6 class="title-grafic side-l">
															Spend Plan
														</h6>
													</div>
													<div class="col-12 col-sm-12 col-md-12 col-lg-12">
														<hr />
													</div>
												</div>
												<div style="height:430px">
													<jscharting :mutable="false" ref="chart2" :options="OptionsHorasServicio" :class="'ml-0 pl-0'" style="height:460px"></jscharting>
												</div>
											</b-overlay>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</CLoader>
		
	</section>
</template>

<script>
import CLoader from "@/components/CLoader.vue";
export default {
	name:'dashboardproyecto',
	props:['pIdProyecto'],
	components:{CLoader},
	data() {
		return {
			ConfigLoad:{
				ShowLoader:true,
				ClassLoad:true
			},
			IdProyecto:0,
			ValorContrato:0,
			ValorContratoPorcen:100,
			VentaActual:0,
			VentaActualPorcen:100,
			CostoOperativo:0,
			CostoOperativoPorcen:0,
			GA:0,
			GAPorcen:25,
			GastoTotal:0,
			GastoTotalPorcen:0,
			GastoOperativo:0,
			GastoOperativoPorcen:0,
			VarianzaOperativo:0,
			VarianzaOperativoPorcen:0,
			CostoEmpresaPlan:0,
			CostoEmpresaPlanPorcen:0,
			CostoEmpresaActual:0,
			CostoEmpresaActualPorcen:0,
			VarianzaCostoEmpresa:0,
			VarianzaCostoEmpresaPorcen:0,
			GastoGA:0,
			GastoGAPorcen:0,
			Facturado:0,
			FacturadoPorcen:0,
			Cobrado:0,
			CobradoPorcen:0,
			PorFacturar:0,
			PorFacturarPorcen:0,
			Estimado:0,
			EstimadoPorcen:0,
			UtilidadActual:0,
			UtilidadActualPorcen:0,
			UtilidadPlan:0,
			UtilidadPlanPorcen:0,
			Financiamiento:0,
			FinanciamientoPorcen:0,
			Adicionales:0,
			AdicionalesPorcen:0,
			ProgresoTiempo:0,
			ProgresoObra:0,
			Equipos:0,
			Materiales:0,
			ManoObra:0,
			Vehiculos:0,
			Contratistas:0,
			Viaticos:0,
			Burden:0,
			ShowPieCostoTotal:false,
			OptionsCostoTotal:{
				chart: {
					type: "donut",
					width: 380,
					height: 280,
					dropShadow: {
    					enabled: true,
    					color: '#111',
    					top: -1,
    					left: 3,
    					blur: 3,
    					opacity: 0.5,
    				},
				},
				dataLabels:{
					enabled: false,
					formatter(val, opts) {
                		// return opts.w.config.series[opts.seriesIndex];
						let fixed = 0;
						let e=0;
						if (opts.w.config.series[opts.seriesIndex] === null) {
							return null;
						} // terminate early
						if (opts.w.config.series[opts.seriesIndex] === 0) {
							return "0";
						} // terminate early
						fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
						var b = opts.w.config.series[opts.seriesIndex].toPrecision(2).split("e"), // get power
							k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 6), // floor at decimals, ceiling at trillions
							c =
								k < 1
									? opts.w.config.series[opts.seriesIndex].toFixed(0 + fixed)
									: (opts.w.config.series[opts.seriesIndex] / Math.pow(10, k * 6)).toFixed(1 + fixed), // divide by power
							d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
							if (k==0) {
								// e=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',roundingPriority:'morePrecision'}).format(d);
								e=d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
							}
							else{
								e = d + ["", " M", " B", " T"][k]; // append power
							}
						return e;
              		},
					style:{
						fontSize:'19px',
						fontWeight:'bold',
						fontFamily:'Arial'
					},
					background:{
						dropShadow:{
							enabled:true,
							top: 1,
      						left: 1,
      						blur: 1,
							opacity:1
						},
					},
					textAnchor:'start'
				},
				plotOptions:{
					pie: {
						donut:{
							labels:{
								value:{
									fontWeight:'bold'
								},
								show:true,
								total:{
									showAlways:true,
									show:true,
									color:'#000',
									fontWeight:'bold',
									formatter:()=>{
										return '$'+this.formateoMillon(parseFloat(this.VentaActual))
									}
								}
							}
						},
						startAngle: -90,
      					endAngle: 270,
              		  	dataLabels: {
              		  	  offset: -25,
              		  	},
              		},
				},
				tooltip:{
					y:{
						formatter(val){
							let fixed = 0;
							let e=0;
							if (val === null) {
								return null;
							} // terminate early
							if (val === 0) {
								return "0";
							} // terminate early
							fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
							var b = val.toPrecision(2).split("e"), // get power
								k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 6), // floor at decimals, ceiling at trillions
								c =
									k < 1
										? val.toFixed(0 + fixed)
										: (val / Math.pow(10, k * 6)).toFixed(1 + fixed), // divide by power
								d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
								if (k==0) {
									// e=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',roundingPriority:'morePrecision'}).format(d);
									e=d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
								}
								else{
									e = d + ["", " M", " B", " T"][k]; // append power
								}
							return e;
						},
					},
					custom: function ({series,seriesIndex,dataPointIndex,w}) {
                    	// console.log(w.config);
						return (
                    	    '<div class="" style="background-color:'+w.config.colors[seriesIndex]+';font-size:16px;">' +
                    	    "<span>" +
                    	    w.config.labels[seriesIndex]+': $'+series[seriesIndex]
							+
                    	    "</span>" +
                    	    "</div>"
                    	);
                	},
					style:{
						fontSize:'14px'
					},
				},
				labels:['Venta Actual','Adicionales'],
				responsive:[{
					breakpoint: 480,
					options:{
						chart: {
							width:200
						}
					}
				}],
				legend:{
					show:false
				},
				colors:['#038ED9', '#1B17BB'],
				fill:{
					type:'gradient'
				},
				stroke:{
					width:1
				}
			},
			SeriesCostoTotal:[0,0],
			ShowPieCostoOperativo:false,
			OptionsCostoOperativo:{
				chart: {
					type: "donut",
					width: 380,
					height: 280,
					dropShadow: {
    					enabled: true,
    					color: '#111',
    					top: -1,
    					left: 3,
    					blur: 3,
    					opacity: 0.5,
    				},
				},
				dataLabels:{
					enabled: false,
					formatter(val, opts) {
                		// return opts.w.config.series[opts.seriesIndex];
						let fixed = 0;
						let e=0;
						if (opts.w.config.series[opts.seriesIndex] === null) {
							return null;
						} // terminate early
						if (opts.w.config.series[opts.seriesIndex] === 0) {
							return "0";
						} // terminate early
						fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
						var b = opts.w.config.series[opts.seriesIndex].toPrecision(2).split("e"), // get power
							k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 6), // floor at decimals, ceiling at trillions
							c =
								k < 1
									? opts.w.config.series[opts.seriesIndex].toFixed(0 + fixed)
									: (opts.w.config.series[opts.seriesIndex] / Math.pow(10, k * 6)).toFixed(1 + fixed), // divide by power
							d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
							if (k==0) {
								// e=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',roundingPriority:'morePrecision'}).format(d);
								e=d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
							}
							else{
								e = d + ["", " M", " B", " T"][k]; // append power
							}
						return e;
              		},
					style:{
						fontSize:'19px',
						fontWeight:'bold',
						fontFamily:'Arial'
					},
					// background:{
					// 	dropShadow:{
					// 		enabled:true,
					// 		top: 1,
      				// 		left: 1,
      				// 		blur: 1,
					// 		opacity:1
					// 	},
					// },
					textAnchor:'start'
				},
				plotOptions:{
					pie: {
						donut:{
							labels:{
								value:{
									fontWeight:'bold'
								},
								show:true,
								total:{
									showAlways:true,
									show:true,
									label:'Varianza',
									formatter:()=>{
										return '$'+this.formateoMillon(parseFloat(this.VarianzaOperativo))
									},
									color:'#000',
									fontWeight:'bold',
								},
							}
						},
						startAngle: -90,
      					endAngle: 270,
              		  dataLabels: {
              		    offset: -25,
              		  },
              		},
				},
				tooltip:{
					y:{
						formatter(val){
							let fixed = 0;
							let e=0;
							if (val === null) {
								return null;
							} // terminate early
							if (val === 0) {
								return "0";
							} // terminate early
							fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
							var b = val.toPrecision(2).split("e"), // get power
								k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 6), // floor at decimals, ceiling at trillions
								c =
									k < 1
										? val.toFixed(0 + fixed)
										: (val / Math.pow(10, k * 6)).toFixed(1 + fixed), // divide by power
								d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
								if (k==0) {
									// e=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',roundingPriority:'morePrecision'}).format(d);
									e=d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
								}
								else{
									e = d + ["", " M", " B", " T"][k]; // append power
								}
							return e;
						},
					},
					custom: function ({series,seriesIndex,dataPointIndex,w}) {
                    	// console.log(w.config);
						return (
                    	    '<div class="" style="background-color:'+w.config.colors[seriesIndex]+';font-size:16px;">' +
                    	    "<span>" +
                    	    w.config.labels[seriesIndex]+': $'+series[seriesIndex]
							+
                    	    "</span>" +
                    	    "</div>"
                    	);
                	},
					style:{
						fontSize:'14px'
					},
				},
				labels:['Gasto Operativo Plan','Gasto Operativo Actual'],
				responsive:[{
					breakpoint: 480,
					options:{
						chart: {
							width:200
						}
					}
				}],
				legend:{
					show:false
				},
				colors:['#038ED9', '#1B17BB'],
				fill:{
					type:'gradient'
				},
				stroke:{
					width:1
				}
			},
			SeriesCostoOperativo:[0,0],
			ShowRubros:false,
			OptionsRubros:{
				chart: {
                	type: 'bar',
                	height: 280,
                	toolbar: {
                	    show: false
                	},
            	},
				plotOptions: {
            	    bar: {
            	        horizontal: true,
            	        barHeight: '80%',
            	        distributed: true,
            	        dataLabels: {
            	            position: 'top',
            	        },
            	    },
            	},
				dataLabels:{
					enabled: true,
                	offsetX: 100,
					formatter: (value,{seriesIndex,dataPointIndex,w})=>{
						// console.log(w.config.yaxis[0].max);
						let sum = w.config.yaxis[0].max;
              			let percent = isNaN((value / sum) * 100) ? 0 : (value / sum) * 100;
						// this.flag=false;
                    	return "$" + this.formateoMillon(value)+' - '+percent.toFixed(0)+'%';
					},
					style: {
                    	fontSize: '13px',
                    	colors: ['']
                	}
				},
				stroke: {
                	show: true,
                	width: 1,
                	colors: ['#fff']
            	},
				tooltip: {
            	    custom: function ({
            	        series,
            	        seriesIndex,
            	        dataPointIndex,
            	        w
            	    }) {
            	        return (
            	            '<div class="arrow_box">' +
            	            "<span>" +
            	            w.globals.labels[dataPointIndex] +
            	            ": " + "$"+
            	            series[seriesIndex][dataPointIndex].toFixed(1)+
            	            "</span>" +
            	            "</div>"
            	        );
            	    }
            	},
				xaxis: {
                	categories: ['Equipos','Materiales', 'Mano de Obra', 'Vehículos','Contratistas','Viáticos','Burden'],
                	labels: {
                	    show: true,
                	    formatter: (value) => {
                	        return "$" + this.formateoMillon(value)

                	    },
                	    style: {
                	        colors: ['#0F3F87'],
                	        fontSize: '13px',
                	        fontFamily: 'Barlow, sans-serif',
                	        fontWeight: 400,
                	        cssClass: 'apexcharts-xaxis-label',
                	    }
                	},

            	},
				colors: ['#038ED9'],
				legend:{
					show:false
				},
				yaxis: [{
            	    labels: {
            	        style: {
            	            colors: ['#0F3F87'],
            	            fontSize: '13px',
            	            fontFamily: 'Barlow, sans-serif',
            	            fontWeight: 'bold',
            	        },
            	    },
					min:0,
					max:this.GastoTotal,
            	}],
				
			},
			SeriesRubros:[],
			rangeDate:{
				start:null,
				end:null
			},
			IsGraphicFilterVisible:false,
			OptionsHorasServicio:{
				debug:false,
                type:'horizontal column solid',
				legend_visible:false,
            	yAxis:{
            	    scale_range:{min:0, padding:0.1},
            	    orientation:'opposite',
            	},
            	xAxis:{
					overflow:'scroll',
            	    defaultTick_label_width: 150,
					caOffset:5, 
            	    crosshair: { 
            	        enabled: true, 
            	        gridLine_visible: false, 
            	        outline_width: 0, 
            	        label_style_fontWeight: 'bold'
            	    } 
            	},
            	defaultSeries_palette: ['#CFD8DC'],
            	defaultPoint: { 
            	    outline_width: 0, 
            	    tooltip: `<b>$%yValue</b>`,
					label:{
						text: '%originalValue %',
					}
            	},
            	defaultTooltip_label_text: '%points',
            	series:[]
            },
			OptionsGraficaTiempo:{
				debug:false,
				type: 'gauge',
				xAxis: { spacingPercentage: 0.25 },
				yAxis:{
					defaultTick: { 
                      padding: 6, 
                      label_style_fontSize: '14px'
                    }, 
                    line: { 
                      width: 10, 
                      color: 'smartPalette:pal1', 
                      breaks_gap: 0 
                    }, 
                    scale_range: [0, 100]
				},
				defaultSeries:{
					type: 'gauge column roundcaps',
					defaultPoint_tooltip:'<b>%name</b> %yValue%',
					angle: { sweep: 180 },
					shape: { 
                        innerSize: '70%', 
                        label: { 
                            text: 
                                '<span color="%color">{%sum:n0}%</span>', 
                            style_fontSize: '46px', 
                            verticalAlign: 'middle'
                        } 
                    }
				},
				series: [ 
                    { 
                        type: 'column roundcaps',
                        palette: {
                            id:'pal1',
					        pointValue: '%yValue',
					        ranges:[{value:[0,25],color:'green'},{value:[25,75],color:'orange'},{value:[75,100],color:'red'}]
                        }, 
                        points: [
                            { 
                                id: '1', 
                                x: 'Tiempo', 
                                y: 0 
                            }
                        ] 
                    } 
                ],
				legend:{
					visible:false
				}
			},
			OptionsGraficaObra:{
				debug:false,
				type: 'gauge',
				xAxis: { spacingPercentage: 0.25 },
				yAxis:{
					defaultTick: { 
                      padding: 6, 
                      label_style_fontSize: '14px'
                    }, 
                    line: { 
                      width: 10, 
                      color: 'smartPalette:pal1', 
                      breaks_gap: 0 
                    }, 
                    scale_range: [0, 100]
				},
				defaultSeries:{
					type: 'gauge column roundcaps',
					angle: { sweep: 180 },
					defaultPoint_tooltip:'<b>%name</b> %yValue%', 
					shape: { 
                        innerSize: '70%', 
                        label: { 
                            text: 
                                '<span color="%color">{%sum:n0}%</span>', 
                            style_fontSize: '46px', 
                            verticalAlign: 'middle'
                        } 
                    }
				},
				series: [ 
                    { 
                        type: 'column roundcaps',
                        palette: {
                            id:'pal1',
					        pointValue: '%yValue',
					        ranges:[{value:[0,20],color:'red'},{value:[20,80],color:'orange'},{value:[80,100],color:'green'}]
                        }, 
                        points: [
                            { 
                                id: '1', 
                                x: 'Obra', 
                                y: 0 
                            }
                        ] 
                    } 
                ],
				legend:{
					visible:false
				}
			},
			IdCliente:'',
			IdClienteS:'',
			IdContrato:'',
			isOverlay:true
		}
	},
	methods: {
		mostrarfiltro(){
			this.IsGraphicFilterVisible = true;
		},
		OcultarFiltro(){
			this.IsGraphicFilterVisible = false;
		},
		async GetTipoServicio(){
			this.isOverlay=true;
			await this.$http.get("despachooneequipo/get",{
                params:{
                    Fecha_I: this.rangeDate.start,
					Fecha_F: this.rangeDate.end,
					IdCliente:this.IdCliente,
					IdClienteS:this.IdClienteS,
					IdContrato:this.IdContrato
                }
            }).then((res)=>{
                this.ConfigLoad.ShowLoader = false;
				res.data.data.sort((a,b)=>b.value - a.value)
                let points=res.data.data.map((element)=>{
					return {
                            x:element.label,
							opacity:1,
                            y:Number(element.value),
							color:element.color,
							xAxisTick_label_text: this.$limitCharacters(element.label,18),
							xAxisTick_label_color: '#373D3F'
                        }
				});
				// points.sort((a, b) => b.y - a.y);
				this.OptionsHorasServicio.series=
					[
						{
							points:points
						}
					]
				this.isOverlay=false;
            })
		},
		async GetInfo(){
			await this.$http.get('proyectosdashboard/get',{
				params:{
					IdProyecto:this.IdProyecto
				}
			}).then((res) => {
				//SETEANDO FILTROS PARA LA SEGUNDA GRAFICA
				this.IdCliente=res.data.data.IdCliente;
				this.IdClienteS=res.data.data.IdClienteS;
				this.IdContrato=res.data.data.IdContrato;
				let formatedDateInicio=res.data.data.FechaInicio.replace(/-/g, "\/");
				this.rangeDate.start=new Date(formatedDateInicio);
				let formatedDateFin=res.data.data.FechaFin.replace(/-/g, "\/");
				this.rangeDate.end=new Date(formatedDateFin);

				this.ValorContrato=res.data.data.Venta;
				this.VentaActual=res.data.data.VentaActual;
				this.VentaActualPorcen=res.data.data.VentaActualPorcen;
				this.CostoOperativo=res.data.data.CostoOperativo;
				this.CostoOperativoPorcen=res.data.data.CostoOperativoPorcen;
				this.VarianzaOperativo=res.data.data.VarianzaOperativo;
				this.VarianzaOperativoPorcen=res.data.data.VarianzaOperativoPorcen;
				this.CostoEmpresaPlan=res.data.data.CostoEmpresaPlan;
				this.CostoEmpresaPlanPorcen=res.data.data.CostoEmpresaPlanPorcen;
				this.CostoEmpresaActual=res.data.data.CostoEmpresaActual;
				this.CostoEmpresaActualPorcen=res.data.data.CostoEmpresaActualPorcen;
				this.VarianzaCostoEmpresa=res.data.data.VarianzaCostoEmpresa;
				this.VarianzaCostoEmpresaPorcen=res.data.data.VarianzaCostoEmpresaPorcen;
				this.GA=res.data.data.GA;
				this.GastoTotal=res.data.data.CostoOperativo;
				this.GastoTotalPorcen=res.data.data.CostoOperativoPorcen;
				this.GastoOperativo=res.data.data.GastoOperativo;
				this.GastoOperativoPorcen=res.data.data.GastoOperativoPorcen;
				this.Facturado=res.data.data.Facturado;
				this.FacturadoPorcen=res.data.data.FacturadoPorcen;
				this.Cobrado=res.data.data.Cobrado;
				this.CobradoPorcen=res.data.data.CobradoPorcen;
				this.PorFacturar=res.data.data.PorFacturar;
				this.PorFacturarPorcen=res.data.data.PorFacturarPorcen;
				this.Estimado=res.data.data.Estimado;
				this.EstimadoPorcen=res.data.data.EstimadoPorcen;
				this.UtilidadPlan=res.data.data.UtilidadPlan;
				this.UtilidadPlanPorcen=res.data.data.UtilidadPlanPorcen;
				this.Financiamiento=res.data.data.Financiamiento;
				this.FinanciamientoPorcen=res.data.data.FinanciamientoPorcen;
				this.Adicionales=res.data.data.Adicionales;
				this.AdicionalesPorcen=res.data.data.AdicionalesPorcen;
				this.ProgresoTiempo=res.data.data.ProgresoTiempo;
				this.ProgresoObra=res.data.data.Progreso;
				this.UtilidadActual=res.data.data.UtilidadActual
				this.UtilidadActualPorcen=res.data.data.UtilidadActualPorcen;

				// let ElementoTiempo=document.getElementById('progresotiempo');
				// let ElementoObra=document.getElementById('progresoobra');
				// ElementoTiempo.style.width=Number(this.ProgresoTiempo)>=100 ? 100+'%' : this.ProgresoTiempo+'%';
				// ElementoObra.style.width=Number(this.ProgresoObra)>=100 ? 100+'%' : this.ProgresoObra+'%';
				let ProgresoTiempo=Number(this.ProgresoTiempo);
				this.OptionsGraficaTiempo.series[0].palette.pointValue='%yValue';
				this.OptionsGraficaTiempo.yAxis.scale_range[1]=ProgresoTiempo>=100 ? ProgresoTiempo : 100;
				this.OptionsGraficaTiempo.series[0].points[0].y=ProgresoTiempo;

				let ProgresoObra=Number(this.ProgresoObra);
				this.OptionsGraficaObra.series[0].palette.pointValue='%yValue';
				this.OptionsGraficaObra.yAxis.scale_range[1]=ProgresoObra>=100 ? ProgresoObra : 100;
				this.OptionsGraficaObra.series[0].points[0].y=ProgresoObra;

				let NewArray=[
					{label:'Equipos',value:res.data.data.Equipos,porcen:res.data.data.EquiposPorcen},
					{label:'Materiales',value:res.data.data.Materiales,porcen:res.data.data.MaterialesPorcen},
					{label:'Mano de Obra',value:res.data.data.ManoObra,porcen:res.data.data.ManoObraPorcen},
					{label:'Vehículos',value:res.data.data.Vehiculos,porcen:res.data.data.VehiculosPorcen},
					{label:'Contratistas',value:res.data.data.Contratistas,porcen:res.data.data.ContratistasPorcen},
					{label:'Viáticos',value:res.data.data.Viaticos,porcen:res.data.data.ViaticosPorcen},
					{label:'Burden',value:res.data.data.Burden,porcen:res.data.data.BurdenPorcen}
				];
				// this.SeriesRubros = [{
				// 	data: NewArray,
				// }];
				// NewArray.sort((a,b)=>b.value - a.value);
				let points=NewArray.map((element)=>{
					return {
                            x:element.label,
							opacity:1,
                            y:Number(element.value),
							attributes:{
								// originalValue: ((Number(element.value)/Number(this.GastoTotal))*100).toFixed(0),
								originalValue: (Number(element.porcen)).toFixed(0),
							},
							color:'#0069EA',
							xAxisTick_label_text: this.$limitCharacters(element.label,18),
							xAxisTick_label_color: '#373D3F'
                        }
				});
				// points.sort((a, b) => b.y - a.y);
				this.OptionsHorasServicio.series=
					[
						{
							points:points
						}
					];
				// console.log(this.OptionsHorasServicio.yAxis);
				// this.OptionsHorasServicio.yAxis.scale_range.max=this.GastoTotal;
				// this.OptionsRubros.xaxis[0].max=this.GastoOperativo;
				this.isOverlay=false;
				// this.SeriesRubros[7],res.data.data.Equipos;
				// GRAFICA DE COSTO TOTAL
				this.SeriesCostoTotal[0]=this.VentaActual;
				this.SeriesCostoTotal[1]=this.Adicionales;
				this.SeriesCostoOperativo[0]=this.CostoOperativo;
				this.SeriesCostoOperativo[1]=this.GastoOperativo;
				// this.SeriesPlanAdicionales[0]=this.ValorContrato;
				// this.SeriesPlanAdicionales[1]=this.Adicionales;
			}).finally(()=>{
				this.ShowPieCostoTotal=true;
				this.ShowPieCostoOperativo=true;
				this.ShowPiePlanAdicionales=true;
				this.ShowRubros=true;
				this.ConfigLoad.ShowLoader=false;
				// this.GetTipoServicio();
			})
		},
		Regresar(){
			this.$router.push({name:'proyectodesglose'});
		},
		formateoMillon(numero){
            let fixed = 0;
			let e=0;
			if (numero === null) {
				return null;
			} // terminate early
			if (numero === 0) {
				return "0";
			} // terminate early
			fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
			var b = numero.toPrecision(2).split("e"), // get power
				k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 6), // floor at decimals, ceiling at trillions
				c =
					k < 1
						? numero.toFixed(0 + fixed)
						: (numero / Math.pow(10, k * 6)).toFixed(1 + fixed), // divide by power
				d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
				if (k==0) {
					// e=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',roundingPriority:'morePrecision'}).format(d);
					e=d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				}
				else{
					e = d + ["", " M", " B", " T"][k]; // append power
				}
			return e;
        },
	},
	created() {
		// var date = new Date(),
		// y = date.getFullYear(),
		// m = date.getMonth();
		// var firstDay = new Date(y, m, 1);
		// var lastDay = new Date(y, m + 1, 0);
		// this.rangeDate = {
		// 	start: firstDay,
		// 	end: lastDay
		// };

		if (this.pIdProyecto!=undefined) {
			sessionStorage.setItem("IdProyecto",this.pIdProyecto);
		}
		this.IdProyecto=sessionStorage.getItem("IdProyecto");
	},
	async mounted() {
		await this.$nextTick();
		setTimeout(() => {
			this.GetInfo();	
		}, 500);
		
	},
}
</script>

<style>

</style>
